import React from 'react';
import { RailsCategory } from '@sls-react/typings/services/rails/item';
import { useRouter } from '@sls-react/routing';
import { useQuery } from 'react-query';
import { fetchCategories } from '@sls-react/api/categories';

export const CategoriesContext = React.createContext<
  RailsCategory[] | undefined
>(undefined);

export default function useCategoriesContext() {
  const { data } = useQuery('categories', fetchCategories, {
    staleTime: 600000,
    cacheTime: 600000,
  });
  return data;
}

export function useRouteSpecificCategories() {
  const router = useRouter();
  const categories = useCategoriesContext();

  if (
    typeof window === 'undefined' &&
    (router.route === '/gear/[...item]' || router.route === '/shop/[...lander]')
  ) {
    const currentPageCategory: string | undefined = router.query?.item?.[0];
    if (currentPageCategory) {
      return categories?.map(category => {
        if (category.slug !== currentPageCategory) {
          return {
            ...category,
            children: [],
          };
        } else {
          return category;
        }
      });
    }
  }

  return categories;
}
